export default "__VITE_ASSET__kHb7Ho2Q__"